import './EclipseMaterial';
import './preprocessShaderEclipse';
import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Vector2 } from 'three';
import { useAsset } from '@artica/assets';

export default function Eclipse({
  speed = 1,
  delta = 60 / 10000,
  ...fogParams
}) {
  const textureEclipseCloud = useAsset('cloud');
  const textureEclipseLav = useAsset('lav');
  const materialRef = useRef();

  useFrame(() => {
    const { current: mat } = materialRef;
    const t = mat.uniforms.time.value + (delta * speed);
    mat.uniforms.time.value = t;
  });

  return (
    <eclipseMaterial
      ref={ materialRef }
      time={ 1 }
      uvScale={ new Vector2(2, 3) }
      texture1={ textureEclipseCloud }
      texture2={ textureEclipseLav }
      { ...fogParams }
    />
  );
};